import KycForm from "../components/KycForm";

const KycFormPage = () => (
  <div className="relative z-10 w-full px-4 sm:px-6">
    {/* <div className="mb-8 flex justify-center">
      <img src="/logo_kyc.png" alt="kyc" className="h-[320px] w-[270px] sm:h-[360px] sm:w-[337px]" />
    </div> */}
    <div className="mx-auto w-full max-w-3xl">
      <KycForm />
    </div>
  </div>
);

export default KycFormPage;
